import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"container-view"},[_c(VFadeTransition,[(_vm.isShow)?_c(VContainer,{staticClass:"py-8"},[_c('div',{staticClass:"fuwa-title mt-2 mb-2"},[_vm._v("謎解きの部屋")]),_vm._v(" "),_c('div',{staticClass:"description-text mb-2"},[_vm._v("\n        謎解きを無料で楽しめるお部屋がこちらです。\n      ")])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }